import type { AgentQuickAction } from '@/shared/api/agentApi';

export interface CallContext {
  phone?: string | null;
  name?: string | null;
  call_id?: string | null;
  agent?: string | null;
}

/**
 * Replace the {{phone}} {{name}} {{call_id}} {{agent}} placeholders in a
 * quick-action URL with the current lead/call values (URL-encoded). Unknown
 * placeholders are left untouched; missing values become an empty string.
 */
export function resolveQuickActionUrl(url: string, ctx: CallContext): string {
  const map: Record<string, string> = {
    phone: ctx.phone ?? '',
    name: ctx.name ?? '',
    call_id: ctx.call_id ?? '',
    agent: ctx.agent ?? '',
  };
  return url.replace(/\{\{\s*(phone|name|call_id|agent)\s*\}\}/g, (_m, key: string) =>
    encodeURIComponent(map[key] ?? ''),
  );
}

export type { AgentQuickAction };
